import { render, staticRenderFns } from "./ProjectSetteiPage.vue?vue&type=template&id=11af5087&scoped=true&"
import script from "./ProjectSetteiPage.vue?vue&type=script&lang=ts&"
export * from "./ProjectSetteiPage.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectSetteiPage.vue?vue&type=style&index=0&id=11af5087&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11af5087",
  null
  
)

export default component.exports